export const COLOR_SWATCH_MAP: { [key: string]: string } = {
  'black': '#000000',
  'blue': '#5694F8',
  'white': '#FFFFFF',
  'gray': '#808080',
  'brown': '#6C3E19',
  'multi': 'conic-gradient(from 0.26turn, #e15a13, #adc236 0.19turn, #78a65c 0.39turn, #5c82a6 0.61turn, #7255a3 0.84turn, #e15a13)',
  'navy': '#000080',
  'pink': '#FFC0CB',
  'red': '#BE1515',
  'beige': '#F5F5DC',
  'green': '#008000',
  'tan': '#D2B48C',
  'gold': '#FFD700',
  'silver': '#C0C0C0',
  'purple': '#800080',
  'yellow': '#FFE300',
  'orange': '#FFA500',
  'taupe': '#9D8B7D',
  'olive': '#808000',
  'khaki': '#F0E68C',
  'burgundy': '#800020',
  'animal print': 'radial-gradient(circle at 25% 12%, #b77e4c, #9b5d2e 25%, #000000 32%, #b1743d 47%, #bd8046 57%, #000000 67%, #a67945 78%)',
  'neutral': '#E8E8DB',
  'bone': '#FBF8ED',
  'pewter': '#6B6B63',
  'metallic': 'linear-gradient(243deg, #d0ccc9, #cfcbc8, #ffffff, #e8e1db, #d4cdcc, #ccc8c5)',
  'unknown color': '',
  'bronze': '#CD7F31',
  'coral': '#FF7F50',
  'mahogany': '#5D0709',
  'clear': 'linear-gradient(to bottom, #e9e9e9, #ececec 23%, #fafafa 45%, #ffffff 46%, #ededed 84%, #efefef)'
};

/**
 * Swatch sizing constants for the PLP product card. They drive both the calculation of how many
 * swatches fit within a card and the rendered swatch dimensions in ColorSwatches.tsx.
 *
 * Two sets of values run side by side per marketplace; the useSwatchSizing hook selects the set
 * from the marketplace (the redesign is permanent on Zappos; 6pm keeps the legacy set of values):
 *   - LEGACY_*   — 6pm: 34px swatch + 4px padding → 42px footprint.
 *   - REDESIGN_* — Zappos: 26px swatch + 3px padding → 32px footprint.
 *
 * These drive both the dynamic calculation of how many swatches fit within a card
 * and the rendered swatch dimensions. They are the single source of truth shared by:
 *   - ColorSwatches.tsx — the real swatch row (visible-count math + rendered size).
 *   - ProductCard.jsx   — the `mimicSwatchWrapper` placeholder that reserves the
 *                         same footprint on cards without swatches.
 */
export const LEGACY_SWATCH_SIZE = 34;
export const LEGACY_SWATCH_PADDING = 4;
export const LEGACY_SWATCH_SIZE_WITH_PADDING = LEGACY_SWATCH_SIZE + LEGACY_SWATCH_PADDING * 2;

export const REDESIGN_SWATCH_SIZE = 26;
export const REDESIGN_SWATCH_PADDING = 3;
export const REDESIGN_SWATCH_SIZE_WITH_PADDING = REDESIGN_SWATCH_SIZE + REDESIGN_SWATCH_PADDING * 2;

/**
 * Maximum color swatches shown per PLP product card.
 * Colors beyond the cap collapse into the existing "+X" overflow badge.
 */
export const MAX_VISIBLE_SWATCHES = {
  mobile: 4,
  foldableMobile: 5,
  tablet: 6,
  desktop: 6
};
